import { useMemo, useState, useEffect } from "react";
import useSupportsHover from "./useSupportsHover";
import useUniqueId from "./useUniqueId";
// TODO -- put all of the stuff outside of the component into a context of some sort so it works better with
// react-refresh in development.
const subscribers = {};
const position = { x: 0, y: 0 };
let listenerRegistered = false;
const listener = (e) => {
    position.x = e.clientX;
    position.y = e.clientY;
};
const subscribe = (id, callback) => {
    subscribers[id] = callback;
};
const unsubscribe = (id) => {
    if (id in subscribers) {
        delete subscribers[id];
    }
};
setInterval(() => {
    const hasSubscribers = Object.keys(subscribers).length > 0;
    if (!hasSubscribers) {
        document.body.removeEventListener("mousemove", listener);
        position.x = 0;
        position.y = 0;
        listenerRegistered = false;
    }
    else if (!listenerRegistered) {
        document.body.addEventListener("mousemove", listener);
        listenerRegistered = true;
    }
    const hoveredElms = new Set(document.elementsFromPoint(position.x, position.y).map((elm) => elm.id));
    Object.entries(subscribers).forEach(([key, callback]) => {
        callback(hoveredElms.has(key));
    });
}, 1000);
/**
 * onMouseEnter and onMouseLeave events can be unreliable if the mouse enters the element when
 * something in the DOM disappears, or when quickly scrolling.  Therefore, we also check occasionally check
 * to see what the mouse is hovered over.
 */
const useIsElementHovered = () => {
    const [isHovered, setIsHovered] = useState(null);
    const supportsHover = useSupportsHover();
    const id = useUniqueId()[0];
    const provided = useMemo(() => {
        if (!supportsHover) {
            return {
                id,
                onMouseEnter: () => {
                    // do nothing
                },
                onMouseLeave: () => {
                    /* do nothing */
                },
            };
        }
        return {
            id,
            onMouseEnter: () => {
                setIsHovered(true);
            },
            onMouseLeave: () => {
                setIsHovered(false);
            },
        };
    }, [id, supportsHover]);
    useEffect(() => {
        if (supportsHover) {
            subscribe(id, (hovered) => setIsHovered(hovered));
        }
        else {
            unsubscribe(id);
        }
        return () => {
            unsubscribe(id);
        };
    }, [id, supportsHover]);
    return useMemo(() => [provided, supportsHover ? isHovered : false], [isHovered, provided, supportsHover]);
};
export default useIsElementHovered;
